import {Box, Grid, Typography} from '@mui/material';
import {useState} from 'react';
import {useNavigate} from 'react-router';
import MonthlyAnnualSelector from '../../components/monthlyAnnualSelector/MonthlyAnnualSelector';
import {DEFAULT_STRIPE_ROLE} from '../../constants';
import useGetProducts from '../../hook/useGetProducts';
import {signInWithGoogle} from '../../pages/other/LoginPage';
import PricingPlansCard from './PricingPlansCard';

export default function PricingPlans() {
  const [isMonthly, setIsMonthly] = useState(true);
  const navigate = useNavigate();
  const {products, loading, error} = useGetProducts();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%">
        <Typography>Loading pricing plans...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%">
        <Typography color="error">Error loading pricing plans: {error.message}</Typography>
      </Box>
    );
  }

  return (
    <>
      <MonthlyAnnualSelector isMonthly={isMonthly} setIsMonthly={setIsMonthly} />
      <Grid className="pricing-plans-grid" container wrap="wrap" spacing={4} justifyContent="center">
        {products.map((product) => (
          <Grid
            wrap="wrap"
            key={product.id}
            size={{xs: 12, sm: 6, md: Math.ceil(10 / products.length), lg: Math.ceil(10 / products.length)}}
          >
            <PricingPlansCard
              product={product}
              user={null}
              onSelectPlan={async () => {
                await signInWithGoogle();

                navigate(product.id === DEFAULT_STRIPE_ROLE ? '/subscription' : '/');
              }}
              isMonthly={isMonthly}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
